import type { Proposta } from '@/types'

/** Caminho canônico da proposta pública (independe de porta/host antigo salvo no banco). */
export function proposalPublicPath(propostaId: string): string {
  return `/p/${propostaId}`
}

export function resolveProposalPublicLink(proposta: Proposta): string {
  const path = proposalPublicPath(proposta.id)

  if (typeof window !== 'undefined') {
    return `${window.location.origin}${path}`
  }

  const stored = (proposta.linkPublico || proposta.link)?.trim()
  if (stored) {
    try {
      const parsed = new URL(stored)
      return `${parsed.origin}${path}`
    } catch {
      return stored
    }
  }

  return path
}

export function findProposalWithPublicLink(proposals: Proposta[]): Proposta | undefined {
  const sent = proposals.filter((p) => p.status === 'enviada' || p.status === 'aceita')
  const pool = sent.length > 0 ? sent : proposals
  return pool.find((p) => p.linkPublico || p.link) ?? pool[0]
}
